import styled from "@emotion/styled";

import { spacing15 } from "@formant/ui/component/common/Spacing";
import { SearchField } from "@formant/ui/component/picker/SearchField";

import { Help } from "../common/Help";
import { Logo } from "../common/Logo";
import { Scrollable } from "../common/Scrollable";

export const Scroll = Scrollable;

export const ScrollItem = styled.div`
    max-height: 14.75rem;
`;

export const SearchInput = styled(SearchField)`
    padding: 0.625rem;
    padding-top: 0px;
    padding-bottom: 0.315rem;
`;

export const DropdownContainer = styled.div`
    position: relative;
    z-index: 75;
`;

export const HeaderDropdown = styled.ul`
    position: absolute;
    top: 80px;
    left: 20px;
    list-style-type: none;
    margin: 0;
    padding: 5px 0;
    background-color: var(--formant-color-primary-module);
    border: 1px solid var(--formant-color-highlights-blue);
    border-radius: 0 0 0.25rem 0.25rem;
    display: flex;
    flex-direction: column;

    li {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 270px;
        margin: 5px 0;
        padding: 0 13px 0 10px;
        border-left: 3px solid var(--formant-color-primary-module);
        & > :first-child {
            height: 1.125rem;
            display: flex;
            align-items: center;
            & > span {
                margin-left: 10px;
                font-size: 0.8125rem;
                cursor: pointer;
                max-width: 12.5rem;
                color: var(--formant-color-primary-silver);
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }
        & > :last-child {
            height: 1.125rem;
            display: flex;
            align-items: center;
            & > svg {
                margin-left: 10px;
            }
        }
        &:hover {
            border-left: 3px solid var(--formant-color-highlights-blue);
            border-bottom: none;
            & > div > span {
                color: var(--formant-color-primary-white);
            }
        }
    }
    hr {
        margin: 5px 13px 5px 10px;
        width: calc(100% - 23px);
        border: none;
        border-bottom: 1px solid var(--formant-color-primary-steel03);
    }
`;

export const ProfileDropdown = styled.div`
    right: 20px;
    left: auto;
`;

export const RightButtons = styled.div`
    margin-left: 0.4rem;
`;

export const HelpIcon = styled(Help)`
    margin-right: 0.8rem;
    margin-left: 0.3rem;
`;

export const KioskLogo = styled(Logo)`
    height: 1.75rem;
    margin-right: ${spacing15};
    margin-bottom: -0.25rem;
`;
